<template>
  <div class="form">
    <div class="form__content">
      <h1 class="extra-large-headline">Social Security Number</h1>
      <p class="bodycopy">
        Enter your social security number to complete your transaction
      </p>
    </div>
    <form @submit.prevent>
      <FormInputField
        name="ssn"
        label="Social Security Number*"
        placeholder="###-##-####"
        type="text"
        mask="###-##-####"
        :inputValue="form.ssn"
        :errors="usTaxIdStore.getErrorByField('ssn')"
        v-model:ssn="form.ssn"
      />

      <ButtonBase
        :isDisabled="usTaxIdStore.formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        Continue
      </ButtonBase>
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useUSTaxIdStore } from "@/stores/forms/usTaxIDFormStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useApiHelpers from "@/composables/api/helpers";
import useCustomerActions from "@/composables/api/useCustomerActions";
import useWatchAndUpdate from "@/composables/helpers/useWatchAndUpdate";

import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import FormInputField from "@/components/ui/inputs/FormInputField.vue";

const router = useRouter();
const globalStore = useGlobalStore();
const usTaxIdStore = useUSTaxIdStore();

const { postRequest } = useApiHelpers();
const { fetchCustomerId } = useCustomerActions();
const identityQueueStore = useIdentityQueueStore();
const { watchAndUpdateStore } = useWatchAndUpdate();

const form = ref({
  ssn: usTaxIdStore.form.ssn.value || "",
});

const handleFormSubmit = async () => {
  const formData = {
    taxId: form.value.ssn,
  };

  globalStore.setIsFormLoading(true);

  postRequest("customers/ssn", formData, () =>
    router.push(identityQueueStore.getNextIdentityRoute)
  );
};

watchAndUpdateStore(form, usTaxIdStore);
</script>
<style lang="scss" scoped>
.form {
  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
  &__selfie-instructions {
    list-style: unset;
    padding-inline: 1.5rem;

    li {
      font-size: $font-body;
      line-height: 1.5;
    }
  }
}
</style>
